import { Filter } from "./filter";

export class ByTitle extends Filter {
  constructor(public searchphrase: string) {
    super("by.title");
  }
}
